import React from 'react';
import _ from 'lodash';

import {
  CircularProgress,
  ExpansionPanelSummary,
  ExpansionPanel,
  ExpansionPanelDetails,
  TextField,
  Slider, Grid, withStyles
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import useStyles from './styles';
import styles from '../../containers/CustomerDashboard/components/InvestmentDetailsNavigation/WeightSelector/styles'
import {BaseNumberFormat} from "../Inputs";

const RangeSlider = withStyles(styles)(Slider);


const RangeSliderFilter = ({title, errors, handleValuesChanged, disabled, loading, ...props}) => {
  const classes = useStyles();
  const [investedValues, setInvestedValue] = React.useState(props.initialValues);

  React.useEffect(() => {
    // useEffect to update internal state of invested value with passed in props
    setInvestedValue(props.initialValues);
  }, [props.initialValues]);

  const onInputChange = (event, index) => {
    let value = event.target.value || 0; // if user completely removed value - set zero
    if (Number.isFinite(value)) {
      const _values = [...investedValues];
      _values[index] = value;
      setInvestedValue(_values);
    }
  };

  const handleSliderChanged = (event, value) => {
    setInvestedValue(value);
  }

  const handleSliderCommittedChanged = (event, value) => {
    handleValuesChanged(value);
  }

  const onInputBlur = () => {
    if (!_.isNil(handleValuesChanged)) {
      handleValuesChanged(investedValues);
    }
  }

  let roundedLowerBoundary = Math.round(investedValues[0] * 100) / 100
  let roundedUpperBoundary = Math.round(investedValues[1] * 100) / 100

  return (
    <div className={classes.checkboxContainer} id="aggregated-filter-tour-element">
      <ExpansionPanel
        expanded={props.expanded || false}
        classes={{root: classes.checkboxFilterPanelRoot}}
        onChange={() => !disabled && props.onExpandedClick && props.onExpandedClick()}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon
            className={classes.checkboxExpandIcon}
            style={{color: disabled ? '#B1B1B1' : '#0092E5'}}
          />}
          classes={{
            root: classes.checkboxFilterSummaryRoot,
            content: classes.checkboxFilterSummaryContent,
            expandIcon: classes.expandIconSummary
          }}
        >
          <span
            className={classes.checkboxFilterLabelMain}
            style={{color: disabled ? '#B1B1B1' : '#636A71'}}>
            {title}
          </span>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails classes={{ root: classes.checkboxFilterDetailsRoot }}>
          {loading ? (
            <div className={classes.loadingContainer}>
              <CircularProgress className={classes.loadingIndicator}/>
            </div>
          ) : (
            <Grid container alignItems={"center"}>
              <Grid container xs={12} direction={"row"} alignItems={"center"}>
                <Grid item xs={"auto"} alignItems={"center"}>
                  <span style={{marginRight: 5, fontSize: 12, fontFamily: "Roboto-Regular"}}>&#8364;</span>
                </Grid>
                <Grid item xs={5} alignItems={"center"}>
                  <TextField
                    placeholder={props.withMinMaxPlaceholders ? props.range[0] : ''}
                    style={{marginTop: 8}}
                    error={errors && !_.isNil(errors[0])}
                    value={roundedLowerBoundary}
                    onChange={(event) => onInputChange(event, 0)}
                    onBlur={onInputBlur}
                    margin="normal"
                    InputProps={
                      {
                        inputComponent: BaseNumberFormat,
                        className: classes.input,
                        disableUnderline: true,
                        classes: {
                          root: classes.textFieldRoot,
                          underline: classes.textFieldUnderline,
                          focused: classes.textFieldUnderlineFocused,
                          error: classes.inputError
                        }
                      }
                    }
                    InputLabelProps={{
                      shrink: true,

                      classes: {
                        root: classes.labelRoot,
                        focused: classes.labelFocused
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={1} alignItems={"center"}>
                  <div style={{textAlign: "center"}}>
                    <span style={{marginRight: 4, marginLeft: 4, fontFamily: "Roboto-Regular"}}>&#8211;</span>
                  </div>
                </Grid>
                <Grid item xs={5} alignItems={"center"}>
                  <TextField
                    placeholder={props.withMinMaxPlaceholders ? props.range[1] : ''}
                    style={{marginTop: 8}}
                    error={errors && !_.isNil(errors[1])}
                    value={roundedUpperBoundary}
                    onChange={(event) => onInputChange(event, 1)}
                    onBlur={onInputBlur}
                    margin="normal"
                    InputProps={
                      {
                        inputComponent: BaseNumberFormat,
                        className: classes.input,
                        disableUnderline: true,
                        classes: {
                          root: classes.textFieldRoot,
                          underline: classes.textFieldUnderline,
                          focused: classes.textFieldUnderlineFocused
                        }
                      }
                    }
                    InputLabelProps={{
                      shrink: true,
                      classes: {
                        root: classes.labelRoot,
                        focused: classes.labelFocused
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} style={{marginRight: 25}}>
                <RangeSlider
                  value={investedValues}
                  min={props.range[0]}
                  max={props.range[1]}
                  onChange={handleSliderChanged}
                  onChangeCommitted={handleSliderCommittedChanged}
                />
              </Grid>
            </Grid>)}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  )
}

export default RangeSliderFilter;